import { render, staticRenderFns } from "./CollectionsCalendar.vue?vue&type=template&id=37b73df4"
import script from "./CollectionsCalendar.vue?vue&type=script&lang=js"
export * from "./CollectionsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports